import { AbstractControl, ValidationErrors } from '@angular/forms';
import { validationErrorCode } from '../../../core/component/forms/form-control';

type ExecutorSelectionValue = { id?: string; value?: string } | string | null | undefined;

const getExecutorSelectionId = (value: ExecutorSelectionValue): string | null => {
  if (!value) {
    return null;
  }

  if (typeof value === 'string') {
    return value || null;
  }

  return value.id ?? value.value ?? null;
};

export const isExecutorUserInGroup = (
  userValue: ExecutorSelectionValue,
  groupValue: ExecutorSelectionValue,
  userGroupsMap: Map<string, string[]>
): boolean => {
  const selectedUserId = getExecutorSelectionId(userValue);
  const selectedGroupId = getExecutorSelectionId(groupValue);

  if (!selectedUserId || !selectedGroupId) {
    return true;
  }

  return userGroupsMap.get(selectedUserId)?.includes(selectedGroupId) ?? false;
};

export const filterExecutorOptions = <T>(
  options: T[],
  groupValue: ExecutorSelectionValue,
  userGroupsMap: Map<string, string[]>,
  getOptionId: (option: T) => string,
  preservedUserValue?: ExecutorSelectionValue
): T[] => {
  const selectedGroupId = getExecutorSelectionId(groupValue);

  if (!selectedGroupId) {
    return options.slice();
  }

  const preservedUserId = getExecutorSelectionId(preservedUserValue);

  return options.filter(option => {
    const optionId = getOptionId(option);

    if (optionId === preservedUserId) {
      return true;
    }

    return userGroupsMap.get(optionId)?.includes(selectedGroupId) ?? false;
  });
};

// Select component validator
export const executorValidator = (groupIdControl: AbstractControl, userGroupsMap: Map<string, string[]>) => {
  return (webUserControl: AbstractControl): ValidationErrors | null => {
    if (!groupIdControl || !webUserControl) return null;

    const selectedUserId = webUserControl.value;
    const selectedGroupId = groupIdControl.value;

    if (selectedUserId === '' || selectedGroupId === '') return null;

    const userGroups = userGroupsMap.get(selectedUserId);
    const isValid = selectedUserId && userGroups?.indexOf(selectedGroupId) !== -1;

    return isValid
      ? null
      : {
          [validationErrorCode.userGroupMismatch]: {
            message: 'ROUNDING_COMMON.EXECUTOR_VALIDATION_MSG',
            params: {}
          }
        };
      };
};